<template>
  <div style="position: relative;">
    <canvas ref="canvas" width="400" height="400"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js'

export default {
  name: 'BarChart',
  props: {
    chartdata: { type: Object, default: null },
    options:   { type: Object, default: null },
  },
  data () {
    return { chart: null }
  },
  mounted () {
    this.chart = new Chart(this.$refs.canvas, {
      type: 'bar',
      data: this.chartdata || { datasets: [] },
      options: this.options || {},
    })
    this.$emit('set-chart', this.chart)
  },
  watch: {
    // Achtung: kein deep:true - Chart.js mutiert intern chart.options/chart.data
    // (z.B. _cache); bei deep-Watch fuehrt das zu einer Update-Loop. Konsumenten
    // weisen options/chartdata wholesale neu zu, daher reicht der Reference-Watch.
    chartdata (val) {
      if (this.chart) {
        this.chart.data = val || { datasets: [] }
        this.chart.update()
      }
    },
    options (val) {
      if (this.chart) {
        this.chart.options = val || {}
        this.chart.update()
      }
    },
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
}
</script>

